import { createContext, useContext, useEffect, useState } from 'react';
import { MembersService, CommonService } from '../../services';

export const ProfileContext = createContext(undefined);
export const useProfile = () => useContext(ProfileContext);
export function ProfileContextProvider({ children }) {
  const [profile, setProfile] = useState(undefined);

  useEffect(() => {
    (async () => {
      try {
        const [profile, deadline] = await Promise.all([
          MembersService.getUserData(),
          CommonService.getDeadline(),
        ]);
        const isAdmin = await MembersService.validateAdminAccess(
          profile?.email
        );
        // if (profile?.email === "broker@Azachievers.com") {
        //   setProfile({ ...profile, isAdmin: true, ...deadline })
        //   return
        // }
        setProfile({ ...profile, isAdmin, ...deadline });
      } catch (err) {
        console.error(err);
      }
    })();
  }, []);

  return (
    <ProfileContext.Provider value={{ profile }}>
      {children}
    </ProfileContext.Provider>
  );
}
